<!-- TooltipImage.vue -->
<template>
  <el-tooltip :content="content" :placement="placement">
    <div
      class="image-container btn-img"
      @mouseenter="handleTooltipEnter"
      @mouseleave="handleTooltipLeave"
    >
    <slot></slot>
      <!-- <img :src="active ? activeSrc : inactiveSrc" class="btn-img" /> -->
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    handleTooltipEnter() {
      this.active = true;
    },
    handleTooltipLeave() {
      this.active = false;
    },
  },
};
</script>

<style>
/* 你的样式 */
.btn-img {
  /* 图片样式 */
}
</style>
